<template>
	<v-list-item style="border: 1px solid #e0e0e0; border-radius: 5px">
		<v-list-item-icon class="mr-2">
			<v-icon small>mdi-variable</v-icon>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title class="text-caption font-weight-bold">
				{{ variable.name }}
			</v-list-item-title>
		</v-list-item-content>
		<v-list-item-action>
			<v-row no-gutters>
				<v-btn color="primary" icon small @click="showEditVariable = true">
					<v-icon color="primary" small>mdi-pencil</v-icon>
				</v-btn>
        <v-dialog v-model="showEditVariable" max-width="50%" scrollable>
          <v-card>
            <v-card-title class="title primary--text mb-2 secondary">
              <v-icon class="mr-1" color="primary">mdi-variable</v-icon>
              <translate>Edit Variable</translate>
            </v-card-title>
            <v-card-text>
              <VariableForm ref="variableForm" :variable="variable" />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="showEditVariable = false">
                <translate>Cancel</translate>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editVariable" :loading="saving">
                <translate>Save</translate>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
				<v-btn color="primary" icon small @click="deleteVariable" :loading="deleting">
					<v-icon color="primary" small>delete</v-icon>
				</v-btn>
			</v-row>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import axios from "axios";
import VariableForm from './VariableForm.vue'

export default {
  name: "VariableItem",
  props: ["variable"],
  components: {
    VariableForm
  },
  data: () => ({
    showEditVariable: false,
    saving: false,
    deleting: false
  }),
  methods: {
    editVariable() {
      if(this.$refs.variableForm.validate()) {
        this.saving = true;
        axios
          .post("/variables/" + this.variable.id + "/edit", this.variable)
          .then(response => {
            console.log(response.data);
            this.saving = false;
            this.showEditVariable = false;
          })
          .catch(error => {
            console.log(error);
            this.saving = false;
          });
      }
    },
    deleteVariable() {
      this.deleting = true;
      axios
        .post("/variables/" + this.variable.id + "/delete")
        .then(response => {
          console.log(response.data);
          this.$emit('delete-variable', this.variable);
          this.deleting = false;
        })
        .catch(error => {
          console.log(error);
          this.deleting = false;
        });
    }
  }
}
</script>